import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { TimingInterceptor } from '../providers/timing.interceptor';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AuthGuard } from '../auth/auth.guard';
import { AuthService } from '../auth/auth.service';
import { RestService } from '../providers/rest.service';
import { LayoutComponent } from '../layout/layout.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { ToastrModule } from 'ngx-toastr';
import { HelperProvider } from '../providers/helper.provider';
import { AnasayfaComponent } from '../anasayfa/anasayfa.component';
import { GirisComponent } from '../giris/giris.component';
import { KullaniciGruplarComponent } from '../kullanicigruplar/kullanici-gruplar.component';
import { KullanicilarComponent } from '../kullanicilar/kullanicilar.component';
import { SubelerComponent } from '../subeler/subeler.component';
import { TaleplerComponent } from '../talepler/talepler.component';
import { LoadingComponent } from '../loading/loading.component';
import { UrunGruplarComponent } from '../urun-gruplar/urun-gruplar.component';
import { TalepTurlerComponent } from '../talep-turler/talep-turler.component';
import { LoadingInputComponent } from '../loading-input/loading-input.component';
import { TalepOlusturulduComponent } from '../talep-olusturuldu/talep-olusturuldu.component';
import { SubeEkleDuzenleComponent } from '../sube-ekle-duzenle/sube-ekle-duzenle.component';
import { KullaniciEkleDuzenleComponent } from '../kullanici-ekle-duzenle/kullanici-ekle-duzenle.component';
import { KullaniciGrupEkleDuzenleComponent } from '../kullanici-grup-ekle-duzenle/kullanici-grup-ekle-duzenle.component';
import { TalepTurEkleDuzenleComponent } from '../talep-tur-ekle-duzenle/talep-tur-ekle-duzenle.component';
import { UrunGrupEkleDuzenleComponent } from '../urun-grup-ekle-duzenle/urun-grup-ekle-duzenle.component';
import { TalepOnaySeviyelerComponent } from '../talep-onay-seviyeler/talep-onay-seviyeler.component';
import { TalepOnaySeviyeEkleDuzenleComponent } from '../talep-onay-seviye-ekle-duzenle/talep-onay-seviye-ekle-duzenle.component';
import { UrunGrupListeComponent } from '../urun-grup-liste/urun-grup-liste.component';
import { UrunGrupSecModalComponent } from '../urun-grup-sec-modal/urun-grup-sec-modal.component';
import { TalepComponent } from '../talep/talep.component';
import { KullaniciListeComponent } from '../kullanici-liste/kullanici-liste.component';
import { CariEkleDuzenleComponent } from '../cari-ekle-duzenle/cari-ekle-duzenle.component';
import { CarilerComponent } from '../cariler/cariler.component';
import { TekliflerComponent } from '../teklifler/teklifler.component';
import { TalepListeComponent } from '../talep-liste/talep-liste.component';
import { TeklifComponent } from '../teklif/teklif.component';
import { FlatpickrModule } from 'angularx-flatpickr';
import { TeklifListeComponent } from '../teklif-liste/teklif-liste.component';
import { TeklifOlusturulduComponent } from '../teklif-olusturuldu/teklif-olusturuldu.component';
import { SiparislerComponent } from '../siparisler/siparisler.component';
import { SiparisListeComponent } from '../siparis-liste/siparis-liste.component';
import { SiparisOlusturulduComponent } from '../siparis-olusturuldu/siparis-olusturuldu.component';
import { SiparisOlusturComponent } from '../siparis-olustur/siparis-olustur.component';
import { SiparisComponent } from '../siparis/siparis.component';
import { IrsaliyeComponent } from '../irsaliye/irsaliye.component';
import { IrsaliyelerComponent } from '../irsaliyeler/irsaliyeler.component';
import { FaturaComponent } from '../fatura/fatura.component';
import { FaturalarComponent } from '../faturalar/faturalar.component';
import { TalepDetayComponent } from '../talep-detay/talep-detay.component';
import { IrsaliyeListeComponent } from '../irsaliye-liste/irsaliye-liste.component';
import { NotFoundComponent } from '../not-found/not-found.component';
import { MasterListComponent } from '../master-list/master-list.component';
import { MasterComponent } from '../master/master.component';
import { FaturaOlusturulduComponent } from '../fatura-olusturuldu/fatura-olusturuldu.component';
import { FaturaListeComponent } from '../fatura-liste/fatura-liste.component';
import { CariKayitModalComponent } from '../cari-kayit-modal/cari-kayit-modal.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TeklifIstemeFormuComponent } from '../teklif-isteme-formu/teklif-isteme-formu.component';
import { TeklifOlusturulduPublicComponent } from '../teklif-olusturuldu-public/teklif-olusturuldu-public.component';
import { AciklamaGecmisiComponent } from '../aciklama-gecmisi/aciklama-gecmisi.component';
import { NgxMaskModule } from 'ngx-mask';
import { TeklifFiyatGecmisiModalComponent } from '../teklif-fiyat-gecmisi-modal/teklif-fiyat-gecmisi-modal.component';
import { HesapKoduSecModalComponent } from '../hesap-kodu-sec-modal/hesap-kodu-sec-modal.component';
import { RotaOlusturComponent } from '../rota-olustur/rota-olustur.component';
import { AktarildiIsaretleModalComponent } from '../aktarildi-isaretle-modal/aktarildi-isaretle-modal.component';
import { LojistikComponent } from '../lojistik/lojistik.component';
import { LojistikListeComponent } from '../lojistik-liste/lojistik-liste.component';
import { RotaOlusturulduComponent } from '../rota-olusturuldu/rota-olusturuldu.component';
import { LojistikFiyatArsivlerComponent } from '../lojistik-fiyat-arsivler/lojistik-fiyat-arsivler.component';
import { LojistikFiyatArsivListeComponent } from '../lojistik-fiyat-arsiv-liste/lojistik-fiyat-arsiv-liste.component';
import { LojistikFiyatArsivOlusturComponent } from '../lojistik-fiyat-arsiv-olustur/lojistik-fiyat-arsiv-olustur.component';
import { LojistikRotaFiyatlarComponent } from '../lojistik-rota-fiyatlar/lojistik-rota-fiyatlar.component';
import { TasimaciComponent } from '../tasimaci/tasimaci.component';
import { LojistikIrsaliyeListeComponent } from '../lojistik-irsaliye-liste/lojistik-irsaliye-liste.component';
import { KantarComponent } from '../kantar/kantar.component';
import { LojistikIrsaliyeKalemListeComponent } from '../lojistik-irsaliye-kalem-liste/lojistik-irsaliye-kalem-liste.component';
import { DuyurularComponent } from '../duyurular/duyurular.component';
import { DuyuruEkleComponent } from '../duyuru-ekle/duyuru-ekle.component';
import { IrsaliyeLojistikRotaFiyatComponent } from '../irsaliye-lojistik-rota-fiyat/irsaliye-lojistik-rota-fiyat.component';
import { MyFilterPipeFatura } from 'src/pipes/fatura.pipe';
import { MyFilterPipeSum } from 'src/pipes/sum.pipe';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { RotaGecmisComponent } from 'src/rota-gecmis/rota-gecmis.component';
import { AnasayfaGrafikComponent } from 'src/anasayfa-grafik/anasayfa-grafik.component';

@NgModule({
  declarations: [
    AppComponent,
    LayoutComponent,
    AnasayfaComponent,
    GirisComponent,
    KullaniciGruplarComponent,
    KullanicilarComponent,
    SubelerComponent,
    TaleplerComponent,
    LoadingComponent,
    TalepTurlerComponent,
    UrunGruplarComponent,
    TalepComponent,
    LoadingInputComponent,
    TalepOlusturulduComponent,
    SubeEkleDuzenleComponent,
    KullaniciEkleDuzenleComponent,
    KullaniciGrupEkleDuzenleComponent,
    TalepTurEkleDuzenleComponent,
    UrunGrupEkleDuzenleComponent,
    TalepOnaySeviyelerComponent,
    TalepOnaySeviyeEkleDuzenleComponent,
    UrunGrupListeComponent,
    UrunGrupSecModalComponent,
    KullaniciListeComponent,
    CariEkleDuzenleComponent,
    CarilerComponent,
    TekliflerComponent,
    TalepListeComponent,
    TeklifComponent,
    TeklifListeComponent,
    TeklifOlusturulduComponent,
    SiparislerComponent,
    SiparisListeComponent,
    SiparisOlusturComponent,
    SiparisOlusturulduComponent,
    SiparisComponent,
    IrsaliyeComponent,
    IrsaliyelerComponent,
    FaturaComponent,
    FaturalarComponent,
    TalepDetayComponent,
    IrsaliyeListeComponent,
    NotFoundComponent,
    MasterListComponent,
    MasterComponent,
    FaturaOlusturulduComponent,
    FaturaListeComponent,
    CariKayitModalComponent,
    TeklifIstemeFormuComponent,
    TeklifOlusturulduPublicComponent,
    AciklamaGecmisiComponent,
    TeklifFiyatGecmisiModalComponent,
    HesapKoduSecModalComponent,
    RotaOlusturComponent,
    AktarildiIsaretleModalComponent,
    LojistikComponent,
    LojistikListeComponent,
    RotaOlusturulduComponent,
    LojistikFiyatArsivlerComponent,
    LojistikFiyatArsivListeComponent,
    LojistikFiyatArsivOlusturComponent,
    LojistikRotaFiyatlarComponent,
    TasimaciComponent,
    LojistikIrsaliyeListeComponent,
    KantarComponent,
    LojistikIrsaliyeKalemListeComponent,
    DuyurularComponent,
    DuyuruEkleComponent,
    IrsaliyeLojistikRotaFiyatComponent,
    MyFilterPipeFatura,
    MyFilterPipeSum,
    RotaGecmisComponent,
    AnasayfaGrafikComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    ToastrModule.forRoot({
      timeOut: 3000,
      positionClass: 'toast-bottom-left',
      closeButton: true,
      progressBar: true
    }),
    BrowserAnimationsModule,
    FlatpickrModule.forRoot(),
    NgbModule,
    NgxMaskModule.forRoot()
  ],
  exports: [
    LayoutComponent,
  ],
  entryComponents: [],
  providers: [
    RestService,
    AuthService,
    AuthGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TimingInterceptor,
      multi: true
    },
    HelperProvider,
    {provide: LocationStrategy, useClass: HashLocationStrategy}
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {
}
